import { AppState } from '../../bootstrap/redux/state/AppState';

export function selectCatalogingOnSiteEnabled(state: AppState) {
  // Check the server's catalogingOnServerEnabled flag. The value for this also takes into consideration the value
  // of the LD flag which controls the overall Catalog availability in the UI.
  return state.session.info.server.catalogingOnServerEnabled && state.session.info.site.catalogingOnSiteEnabled !== false;
}